import * as Api from '@/utils/request'
import * as QUOTE from "@/utils/quoteRequest";


let baseURL = '',baseURL2 = '';
if (process.env.NODE_PM === 'prod') {
    baseURL = 'https://app.aigupiao.com';
    baseURL2 = 'https://mobile.aigupiao.com';
} else if (process.env.NODE_PM === 'dev') {
    baseURL = 'https://appdev.aigupiao.com';
    baseURL2 = 'https://mobiledev.aigupiao.com';
} else if (process.env.NODE_PM === 'beta') {
    baseURL = 'https://appbeta.aigupiao.com';
    baseURL2 = 'https://mobilebeta.aigupiao.com';
}


export default {

    //https://appbeta.aigupiao.com/goapi/stock/search?keyword=9&u_id=44324&page=1&number=5

    async stockSearch2(keyword) {
        return await Api.get({
            url: baseURL+'/goapi/stock/search?page=1&number=20',
            params: {keyword}
        })
    },

    async stockSearch(keyword) {
        return await Api.get({
            url: baseURL2+'/calf/search',
            params: {keyword}
        })
    },
    async stockDetail(opt){
        return await Api.post({
            url:baseURL+'/stocksDiagnosis/details',
            params:{
                ...opt
            }
        })
    },

    //https://quotedev.aigupiao.com/api/stock_history_adv.php?code=sh601138&ma_a=5&ma_b=10&ma_c=20&type=daily&version=4&adjust=forward&number=30
    //日 daily 周 weekly  月 monthly
    async getk(opt) {
        let res = await QUOTE.get({
            url: "/api/stock_history_adv.php?ma_a=5&ma_b=10&ma_c=20&version=4&adjust=forward&number=60",
            params: {
                ...opt,
                //code=sh601138&
            }
        })
        return res;
    },

    // https://quotedev.aigupiao.com/api/stock_min.php?code=sh601138
    async getfs(opt) {
        let res = await QUOTE.get({
            url: "/api/stock_min.php",
            params: {
                ...opt,
                //code=sh601138&
            }
        })
        return res;
    },

    //https://wwwdev.aigupiao.com/Quote/get_stock_handicap?code=sh601138&source=pc
    
    
    // 股票类型 - A股 QUOTE   https://quotedev.aigupiao.com/api/query.php?list=sh000001
    async getAStock(opt) {
        let res = await QUOTE.get({
            url: "/api/query.php",
            params: {
                ...opt
            }
        })
        return res;
    },

}